import { render } from "./CustomersEditorPage.vue?vue&type=template&id=148b33d8&ts=true"
import script from "./CustomersEditorPage.vue?vue&type=script&lang=ts"
export * from "./CustomersEditorPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__